import { useNavigate } from 'react-router-dom';
import { useGame } from '../context/GameContext';

export function useStartGame() {
  const navigate = useNavigate();
  const { startNewGame, gameState } = useGame();

  const handleStartGame = async () => {
    try {
      await startNewGame();
      navigate('/game');
    } catch (error) {
      console.error('Error in handleStartGame:', error);
    }
  };

  return { handleStartGame, gameState };
}
